import store from "../../index.js";
import AnalyzeConstant from "@/mixins/analyze/const/analyzeConstant.js";
import AnalyzeAcConstant from "@/mixins/analyze/const/analyzeAcConstant.js";
import { callGetApi, callPostApi, callPatchApi, callDeleteApi } from "@/utils/apiWrapper";

export const modules = {
  store,
};

export const state = {
  _items: [],
  _error: {
    code: 0,
    message: "",
  },
};

export const mutations = {
  [AnalyzeConstant.SET_ANALYZE_ERROR](state, item) {
    state._error = item;
  },
};

export const actions = {
  async acBrookCampaign({ commit }, { referrer, items = null }) {
    return await callPostApi({
      url: AnalyzeAcConstant.POST_BROOK_CAMPAIGN,
      data: { referrer, items },
      commit,
      errorMutation: AnalyzeConstant.SET_ANALYZE_ERROR,
    });
  },

  async acBrookTrackingEvent({ commit }, { provider, channel, device_id, referrer }) {
    return await callPostApi({
      url: AnalyzeAcConstant.POST_BROOK_TRACKING_EVENT,
      data: { provider, channel, device_id, referrer },
      commit,
      errorMutation: AnalyzeConstant.SET_ANALYZE_ERROR,
    });
  },

  async acBrookMatchEvent(
    { commit },
    { provider, channel, device_id, tracking_id, expires, first_touch_date },
  ) {
    await callPostApi({
      url: AnalyzeAcConstant.POST_BROOK_MATCH_EVENT,
      data: { provider, channel, device_id, tracking_id, expires, first_touch_date },
      commit,
      errorMutation: AnalyzeConstant.SET_ANALYZE_ERROR,
    });
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
      case 0:
        return "";
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
